import React, { useEffect, useState } from 'react';
import { gql, useQuery, useMutation, useLazyQuery } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import { isLoggedVar } from './cache';
import { UPDATE_TOKEN } from './query';
import CustomAlert from '../common/alert';
import { ONE_MUTUAL } from '../../presentation/containers/parameters/parametersAccount/queries';
import { ONE_USER } from '../../presentation/containers/user/userDetail/queries';

const Auth = ({ children }: { children: any }) => {
  const [updateToken, { data, called }] = useMutation(UPDATE_TOKEN);
  const { data: dataM, called: calledMutual } = useQuery(ONE_MUTUAL, {
    fetchPolicy: 'cache-and-network',
  });

  const [getOneUser, { data: dataU, called: calledUser }] = useLazyQuery(ONE_USER, {
    fetchPolicy: 'no-cache',
  });

  const [hasShownToast, setHasShownToast] = useState(false);
  const [isMount, setIsMount] = useState(false);
  const location = useLocation();
  const uId = window.localStorage.getItem('uId');
  const navigate = useNavigate();

  // Actualiza el auth token del usuario por cada cambio de ventana
  const { data: dataLogged } = useQuery(gql`
    query IsUserLoggedIn {
      isLogged @client
    }
  `);

  useEffect(() => {
    if (uId) {
      getOneUser({ variables: { uId } });
    } else {
      setHasShownToast(false);
    }
  }, [uId, getOneUser]);
  // Verifica el token

  useEffect(() => {
    if (uId && calledUser && calledMutual && dataU && dataM) {
      const currentDate = moment().startOf('day');
      const updateDate = moment(dataU?.getUserById?.uPasswordExpirationDate);
      const updatedDateWithMonths = updateDate.add(
        dataM?.getMutualById?.mPasswordValidityPeriod,
        'months'
      );

      const daysDifference = updatedDateWithMonths.diff(
        currentDate,
        'days',
        dataU?.getUserById?.uPasswordExpirationDate
      );

      if (
        uId &&
        dataM?.getMutualById?.mPasswordValidityPeriod !== 0 &&
        !hasShownToast &&
        dataU?.getUserById?.ucId !== 1
      ) {
        if (daysDifference <= 3 && daysDifference > 0) {
          toast(
            `Le quedan  ${daysDifference === 0 ? 1 : daysDifference} día para actualizar su contraseña.`,
            {
              autoClose: false,
              type: 'info',
              hideProgressBar: true,
              closeOnClick: false,
            }
          );
          setHasShownToast(true);
        } else if (daysDifference < 0 || !daysDifference) {
          navigate(`/configuration/pass/${uId}`);
        }
      }
    }
  }, [dataM, hasShownToast, uId, dataU, calledUser, calledMutual]);

  // Verifica el token
  useEffect(() => {
    updateToken().catch(() => setIsMount(true));
  }, [updateToken]);

  // Respuesta de la verificación del token
  useEffect(() => {
    const res = data?.refreshUserPayrollToken;
    if (called && res) {
      setIsMount(true);
      if (res.tokenAuth) {
        localStorage.setItem('tokenAuth', res.tokenAuth);
        isLoggedVar({ state: true, expired: false, code: '', message: '' });
      } else {
        localStorage.clear();
        const response = localStorage.getItem('tokenAuth');
        isLoggedVar({
          state: false,
          expired: true,
          message: (typeof response === 'string' ? response : '') && 'La sesión ha expirado',
          code: '403',
        });
      }
    }
  }, [data, called]);

  useEffect(() => {
    const res = dataLogged.isLogged;
    if (res.message) {
      isLoggedVar({ ...isLoggedVar(), message: '' });
      if (res.code >= 500 && res.message !== 'No se ha encontrado ningún resultado.')
        <CustomAlert message={res.message} type="error" />;
      else if (
        res.code >= 400 &&
        res.code !== 403 &&
        res.message !== 'No se ha encontrado ningún resultado.'
      )
        <CustomAlert message={res.message} type="warning" />;
      else if (
        (res.code >= 300 || res.code === 403) &&
        res.message !== 'No se ha encontrado ningún resultado.'
      )
        <CustomAlert message={res.message} type="info" />;
      else if (res.code >= 200 && res.message !== 'No se ha encontrado ningún resultado.')
        <CustomAlert message={res.message} type="success" />;
    }
  }, [dataLogged.isLogged]);

  useEffect(() => {
    updateToken().catch(() => setIsMount(true));
  }, [location.pathname, updateToken]);

  return <>{children(dataLogged.isLogged, isMount)}</>;
};

export default Auth;
